import { DefaultTemplate, COR, CORES_SIM_NAO } from './types';

// ============================================================
// RH / DEPARTAMENTO PESSOAL — Recrutamento, Admissão, Férias,
// Desligamento, Treinamentos
// ============================================================

const recrutamento: DefaultTemplate = {
  id: 'tpl_recrutamento',
  name: 'Recrutamento & Seleção',
  descricao: 'Funil completo de vaga: requisição aprovada, triagem, entrevistas, teste técnico, proposta e aceite. Cada candidato é um cartão — você vê o funil inteiro e onde ele trava.',
  categoria: 'rh',
  icone: '🎯',
  etiquetas: [
    { nome: 'Urgente', cor: COR.vermelho },
    { nome: 'Indicação', cor: COR.verde },
    { nome: 'Banco de talentos', cor: COR.azul },
    { nome: 'Reposição', cor: COR.cinza },
  ],
  etapas: [
    {
      id: 'rs_e1', nome: 'Triagem de Currículos',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['rs_c1', 'rs_c2', 'rs_c6'],
      permiteMoverPara: ['rs_e2', 'rs_e7'],
      campos: [
        { id: 'rs_c1', nome: 'Nome do Candidato', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'rs_c2', nome: 'Vaga', tipo: 'texto', obrigatorio: true },
        { id: 'rs_c3', nome: 'E-mail', tipo: 'texto', obrigatorio: true },
        { id: 'rs_c4', nome: 'Telefone', tipo: 'telefone', obrigatorio: false },
        { id: 'rs_c5', nome: 'Currículo', tipo: 'anexo', obrigatorio: true },
        { id: 'rs_c6', nome: 'Origem', tipo: 'lista', obrigatorio: true, opcoes: ['LinkedIn', 'Indicação', 'Site da empresa', 'Banco de talentos', 'Agência', 'Outro'], coresOpcoes: { 'Indicação': COR.verde, 'LinkedIn': COR.azul, 'Banco de talentos': COR.ciano } },
        { id: 'rs_c7', nome: 'Pretensão Salarial', tipo: 'valor', obrigatorio: false },
        { id: 'rs_c8', nome: 'Aderência ao Perfil', tipo: 'lista', obrigatorio: false, opcoes: ['Alta', 'Média', 'Baixa'], coresOpcoes: { 'Alta': COR.verde, 'Média': COR.amarelo, 'Baixa': COR.vermelho } },
      ],
    },
    {
      id: 'rs_e2', nome: 'Entrevista com RH',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['rs_c1', 'rs_c2', 'rs_c10'],
      permiteMoverPara: ['rs_e3', 'rs_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'rs_c9', nome: 'Data da Entrevista', tipo: 'data', obrigatorio: true },
        { id: 'rs_c10', nome: 'Nota do RH (0-10)', tipo: 'numero', obrigatorio: true, valorMinimo: 0, valorMaximo: 10 },
        { id: 'rs_c11', nome: 'Fit Cultural', tipo: 'lista', obrigatorio: false, opcoes: ['Alto', 'Médio', 'Baixo'], coresOpcoes: { 'Alto': COR.verde, 'Médio': COR.amarelo, 'Baixo': COR.vermelho } },
        { id: 'rs_c12', nome: 'Anotações da Entrevista', tipo: 'texto_longo', obrigatorio: false },
        { id: 'rs_c13', nome: 'Avançar?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'rs_e3', nome: 'Teste Técnico',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['rs_c1', 'rs_c15'],
      permiteMoverPara: ['rs_e4', 'rs_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'rs_c14', nome: 'Teste Aplicado', tipo: 'texto', obrigatorio: false },
        { id: 'rs_c15', nome: 'Nota do Teste (0-10)', tipo: 'numero', obrigatorio: true, valorMinimo: 0, valorMaximo: 10 },
        { id: 'rs_c16', nome: 'Entrega do Candidato', tipo: 'anexo', obrigatorio: false },
        { id: 'rs_c17', nome: 'Avaliação Técnica', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'rs_e4', nome: 'Entrevista com Gestor',
      tempoMaximoHoras: 96,
      camposVisiveisNoCard: ['rs_c1', 'rs_c2', 'rs_c19'],
      permiteMoverPara: ['rs_e5', 'rs_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'rs_c18', nome: 'Gestor Entrevistador', tipo: 'texto', obrigatorio: false },
        { id: 'rs_c19', nome: 'Aprovado pelo gestor?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'rs_c20', nome: 'Parecer do Gestor', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'rs_e5', nome: 'Proposta Enviada',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['rs_c1', 'rs_c21', 'rs_c24'],
      permiteMoverPara: ['rs_e6', 'rs_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'rs_c21', nome: 'Salário Proposto', tipo: 'valor', obrigatorio: true },
        { id: 'rs_c22', nome: 'Benefícios Oferecidos', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Vale-refeição', 'Vale-transporte', 'Plano de saúde', 'Plano odontológico', 'Seguro de vida', 'Home office', 'Auxílio educação'] },
        { id: 'rs_c23', nome: 'Data de Início Prevista', tipo: 'data', obrigatorio: false },
        { id: 'rs_c24', nome: 'Proposta aceita?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'rs_e6', nome: 'Contratado',
      camposVisiveisNoCard: ['rs_c1', 'rs_c2', 'rs_c21'],
      permiteCriarCards: false,
      campos: [
        { id: 'rs_c25', nome: 'Data de Admissão', tipo: 'data', obrigatorio: true },
        { id: 'rs_c26', nome: 'Admissão aberta no fluxo de DP?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'rs_e7', nome: 'Não Selecionado',
      camposVisiveisNoCard: ['rs_c1', 'rs_c27'],
      permiteMoverPara: ['rs_e1'],
      permiteCriarCards: false,
      campos: [
        { id: 'rs_c27', nome: 'Motivo', tipo: 'lista', obrigatorio: true, opcoes: ['Perfil não aderente', 'Pretensão acima', 'Reprovado no teste', 'Desistiu', 'Vaga cancelada', 'Recusou a proposta'] },
        { id: 'rs_c28', nome: 'Manter no banco de talentos?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'rs_c29', nome: 'Feedback Enviado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'RH aprovou segue para teste técnico',
      etapaOrigemId: 'rs_e2',
      condicao: { campoId: 'rs_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'rs_e3',
      etapaDestinoSenaoId: 'rs_e7',
    },
    {
      tipo: 'mover',
      nome: 'Gestor aprovou libera a proposta',
      etapaOrigemId: 'rs_e4',
      condicao: { campoId: 'rs_c19', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'rs_e5',
      etapaDestinoSenaoId: 'rs_e7',
    },
    {
      tipo: 'mover',
      nome: 'Proposta aceita vira contratação',
      etapaOrigemId: 'rs_e5',
      condicao: { campoId: 'rs_c24', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'rs_e6',
      etapaDestinoSenaoId: 'rs_e7',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Perguntar sobre banco de talentos só nas recusas por perfil',
      etapaOrigemId: 'rs_e7',
      condicao: { campoId: 'rs_c27', operador: 'igual', valor: 'Perfil não aderente' },
      camposAfetadosIds: ['rs_c28'],
    },
  ],
  cards: [
    { id: 'rs_card1', titulo: 'Ana Beatriz Ferreira', etapaId: 'rs_e4', etiquetas: ['Indicação'], valores: { rs_c1: 'Ana Beatriz Ferreira', rs_c2: 'Analista Financeiro Pleno', rs_c6: 'Indicação', rs_c8: 'Alta', rs_c10: 9, rs_c15: 8 } },
    { id: 'rs_card2', titulo: 'Bruno Carvalho', etapaId: 'rs_e5', etiquetas: ['Urgente'], valores: { rs_c1: 'Bruno Carvalho', rs_c2: 'Desenvolvedor Backend', rs_c6: 'LinkedIn', rs_c8: 'Alta', rs_c21: 9500 } },
    { id: 'rs_card3', titulo: 'Carla Nogueira', etapaId: 'rs_e2', valores: { rs_c1: 'Carla Nogueira', rs_c2: 'Assistente Administrativo', rs_c6: 'Site da empresa', rs_c8: 'Média' } },
    { id: 'rs_card4', titulo: 'Diego Martins', etapaId: 'rs_e1', valores: { rs_c1: 'Diego Martins', rs_c2: 'Desenvolvedor Backend', rs_c6: 'LinkedIn' } },
    { id: 'rs_card5', titulo: 'Elaine Souza', etapaId: 'rs_e6', valores: { rs_c1: 'Elaine Souza', rs_c2: 'Analista de Marketing', rs_c6: 'Indicação', rs_c21: 6800 } },
    { id: 'rs_card6', titulo: 'Felipe Andrade', etapaId: 'rs_e7', etiquetas: ['Banco de talentos'], valores: { rs_c1: 'Felipe Andrade', rs_c2: 'Analista Financeiro Pleno', rs_c27: 'Perfil não aderente', rs_c28: 'Sim' } },
    { id: 'rs_card7', titulo: 'Gabriela Pinto', etapaId: 'rs_e3', valores: { rs_c1: 'Gabriela Pinto', rs_c2: 'Desenvolvedor Backend', rs_c6: 'Agência', rs_c10: 8 } },
  ],
  tour: [
    '🎯 Cada candidato é um cartão. O funil inteiro fica visível numa tela.',
    '1️⃣ "Triagem": currículo, origem e aderência ao perfil.',
    '2️⃣ "Entrevista com RH": nota, fit cultural e a decisão de avançar.',
    '3️⃣ "Teste Técnico": nota e entrega do candidato anexada.',
    '4️⃣ "Entrevista com Gestor": quem vai trabalhar com a pessoa decide.',
    '5️⃣ "Proposta": salário, benefícios e aceite. Aceitou? vira "Contratado" sozinho.',
    '❌ Em qualquer etapa o "Não" leva para "Não Selecionado" com motivo registrado.',
    '💡 Recusado por perfil? O sistema pergunta se vai para o banco de talentos.',
  ],
  etapasDicas: [
    { quemFaz: 'Analista de RH', objetivo: 'Filtrar currículos e registrar a origem — descobre qual canal traz gente boa.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Analista de RH', objetivo: 'Avaliar fit cultural e comunicação antes de gastar tempo do time técnico.', automacoes: ['Já configurado: "Avançar? = Não" leva direto para Não Selecionado'], ondeConfigurar: 'Automações > "RH aprovou segue para teste técnico"' },
    { quemFaz: 'Time técnico da área', objetivo: 'Medir competência real com uma entrega concreta.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Gestor da vaga', objetivo: 'Decisão final de perfil — quem vai liderar a pessoa aprova.', automacoes: ['Já configurado: aprovado libera a proposta'], ondeConfigurar: 'Automações > "Gestor aprovou libera a proposta"' },
    { quemFaz: 'RH + Gestor', objetivo: 'Fechar salário e pacote de benefícios e registrar o aceite.', automacoes: ['Já configurado: proposta aceita move para Contratado'], ondeConfigurar: 'Automações > "Proposta aceita vira contratação"' },
    { quemFaz: 'RH / DP', objetivo: 'Disparar a admissão — daqui o processo continua no fluxo de Admissão.', conexoes: ['Ligue ao fluxo de Admissão: contratado gera automaticamente o card de admissão'], ondeConfigurar: 'Conexões entre Fluxos > Admissão de Colaborador' },
    { quemFaz: 'RH', objetivo: 'Registrar o motivo e alimentar o banco de talentos — candidato bom hoje pode servir amanhã.', automacoes: ['Já configurado: pergunta de banco de talentos aparece só quando o motivo é perfil'], ondeConfigurar: 'Automações > "Perguntar sobre banco de talentos..."' },
  ],
};

const admissao: DefaultTemplate = {
  id: 'tpl_admissao',
  name: 'Admissão de Colaborador',
  descricao: 'Do aceite da proposta ao fim do período de experiência: documentos, exame admissional, registro em eSocial, entrega de equipamentos, integração e avaliações de 45 e 90 dias.',
  categoria: 'rh',
  icone: '📝',
  etiquetas: [
    { nome: 'Pendência documental', cor: COR.vermelho },
    { nome: 'Home office', cor: COR.azul },
    { nome: 'Aprendiz/Estágio', cor: COR.ciano },
  ],
  etapas: [
    {
      id: 'ad_e1', nome: 'Documentação',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['ad_c1', 'ad_c2', 'ad_c8'],
      permiteMoverPara: ['ad_e2'],
      campos: [
        { id: 'ad_c1', nome: 'Nome Completo', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'ad_c2', nome: 'Cargo', tipo: 'texto', obrigatorio: true },
        { id: 'ad_c3', nome: 'Departamento', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH', 'Financeiro'] },
        { id: 'ad_c4', nome: 'Data de Admissão', tipo: 'data', obrigatorio: true },
        { id: 'ad_c5', nome: 'Tipo de Contrato', tipo: 'lista', obrigatorio: true, opcoes: ['CLT', 'Estágio', 'Aprendiz', 'PJ', 'Temporário'], coresOpcoes: { 'CLT': COR.verde, 'Estágio': COR.ciano, 'PJ': COR.roxo } },
        { id: 'ad_c6', nome: 'Salário', tipo: 'valor', obrigatorio: false },
        { id: 'ad_c7', nome: 'Modelo de Trabalho', tipo: 'lista', obrigatorio: false, opcoes: ['Presencial', 'Híbrido', 'Remoto'] },
        { id: 'ad_c8', nome: 'Documentos Recebidos', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['RG', 'CPF', 'CTPS', 'PIS', 'Título de eleitor', 'Comprovante de residência', 'Certidão de nascimento/casamento', 'Foto 3x4', 'Dados bancários', 'Diploma/Certificado'] },
        { id: 'ad_c9', nome: 'Pasta Digital', tipo: 'anexo', obrigatorio: false },
        { id: 'ad_c10', nome: 'Documentação completa?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'ad_e2', nome: 'Exame Admissional',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['ad_c1', 'ad_c13'],
      permiteMoverPara: ['ad_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c11', nome: 'Clínica', tipo: 'texto', obrigatorio: false },
        { id: 'ad_c12', nome: 'Data do Exame', tipo: 'data', obrigatorio: true },
        { id: 'ad_c13', nome: 'Resultado do ASO', tipo: 'lista', obrigatorio: true, opcoes: ['Apto', 'Apto com restrições', 'Inapto'], coresOpcoes: { 'Apto': COR.verde, 'Apto com restrições': COR.amarelo, 'Inapto': COR.vermelho } },
        { id: 'ad_c14', nome: 'ASO', tipo: 'anexo', obrigatorio: false },
        { id: 'ad_c15', nome: 'Restrições', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ad_e3', nome: 'Registro e eSocial',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['ad_c1', 'ad_c17'],
      permiteMoverPara: ['ad_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c16', nome: 'Matrícula', tipo: 'texto', obrigatorio: true },
        { id: 'ad_c17', nome: 'eSocial enviado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'ad_c18', nome: 'Contrato de Trabalho Assinado', tipo: 'anexo', obrigatorio: false },
        { id: 'ad_c19', nome: 'Benefícios Ativados', tipo: 'checkbox_multi', obrigatorio: false, opcoes: ['Vale-refeição', 'Vale-transporte', 'Plano de saúde', 'Plano odontológico', 'Seguro de vida'] },
      ],
    },
    {
      id: 'ad_e4', nome: 'Recursos e Acessos',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['ad_c1', 'ad_c20'],
      permiteMoverPara: ['ad_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c20', nome: 'Itens Entregues', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['Notebook', 'Celular corporativo', 'Crachá', 'Uniforme', 'EPI', 'Cadeira / Estação'] },
        { id: 'ad_c21', nome: 'Acessos Criados', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['E-mail corporativo', 'ERP', 'CRM', 'VPN', 'Ferramentas do time'] },
        { id: 'ad_c22', nome: 'Termo de Responsabilidade', tipo: 'anexo', obrigatorio: false },
        { id: 'ad_c23', nome: 'Tamanho de Uniforme', tipo: 'lista', obrigatorio: false, opcoes: ['PP', 'P', 'M', 'G', 'GG', 'XG'] },
      ],
    },
    {
      id: 'ad_e5', nome: 'Integração / 1º Dia',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['ad_c1', 'ad_c4'],
      permiteMoverPara: ['ad_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c24', nome: 'Itens da Integração', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['Boas-vindas e tour', 'Apresentação ao time', 'Código de conduta', 'Treinamento de segurança', 'Padrinho definido', 'Acesso ao manual interno'] },
        { id: 'ad_c25', nome: 'Padrinho / Buddy', tipo: 'texto', obrigatorio: false },
        { id: 'ad_c26', nome: 'Observações do 1º Dia', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ad_e6', nome: 'Período de Experiência',
      tempoMaximoHoras: 2160,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['ad_c1', 'ad_c27', 'ad_c29'],
      permiteMoverPara: ['ad_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c27', nome: 'Avaliação 45 dias', tipo: 'lista', obrigatorio: false, opcoes: ['Aprovado', 'Atenção', 'Não aprovado'], coresOpcoes: { 'Aprovado': COR.verde, 'Atenção': COR.amarelo, 'Não aprovado': COR.vermelho } },
        { id: 'ad_c28', nome: 'Fim do 1º Período', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'ad_c29', nome: 'Avaliação 90 dias', tipo: 'lista', obrigatorio: false, opcoes: ['Aprovado', 'Atenção', 'Não aprovado'], coresOpcoes: { 'Aprovado': COR.verde, 'Atenção': COR.amarelo, 'Não aprovado': COR.vermelho } },
        { id: 'ad_c30', nome: 'Feedback do Gestor', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'ad_e7', nome: 'Efetivado',
      camposVisiveisNoCard: ['ad_c1', 'ad_c2'],
      permiteCriarCards: false,
      campos: [
        { id: 'ad_c31', nome: 'Data da Efetivação', tipo: 'data', obrigatorio: false },
        { id: 'ad_c32', nome: 'Observações Finais', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Documentação completa libera o exame',
      etapaOrigemId: 'ad_e1',
      condicao: { campoId: 'ad_c10', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ad_e2',
    },
    {
      tipo: 'mover',
      nome: 'eSocial enviado libera recursos e acessos',
      etapaOrigemId: 'ad_e3',
      condicao: { campoId: 'ad_c17', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'ad_e4',
    },
    {
      tipo: 'mover',
      nome: 'Aprovado em 90 dias vira efetivado',
      etapaOrigemId: 'ad_e6',
      condicao: { campoId: 'ad_c29', operador: 'igual', valor: 'Aprovado' },
      etapaDestinoId: 'ad_e7',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar restrições quando houver',
      etapaOrigemId: 'ad_e2',
      condicao: { campoId: 'ad_c13', operador: 'igual', valor: 'Apto com restrições' },
      camposAfetadosIds: ['ad_c15'],
    },
  ],
  cards: [
    { id: 'ad_card1', titulo: 'Elaine Souza', etapaId: 'ad_e4', valores: { ad_c1: 'Elaine Souza', ad_c2: 'Analista de Marketing', ad_c3: 'Marketing', ad_c5: 'CLT', ad_c7: 'Híbrido' } },
    { id: 'ad_card2', titulo: 'Marcos Vinícius Alves', etapaId: 'ad_e1', etiquetas: ['Pendência documental'], valores: { ad_c1: 'Marcos Vinícius Alves', ad_c2: 'Assistente Financeiro', ad_c3: 'Financeiro', ad_c5: 'CLT', ad_c10: 'Não' } },
    { id: 'ad_card3', titulo: 'Larissa Campos', etapaId: 'ad_e6', valores: { ad_c1: 'Larissa Campos', ad_c2: 'Desenvolvedora Frontend', ad_c3: 'TI', ad_c5: 'CLT', ad_c7: 'Remoto', ad_c27: 'Aprovado' } },
    { id: 'ad_card4', titulo: 'Thiago Nunes', etapaId: 'ad_e2', etiquetas: ['Aprendiz/Estágio'], valores: { ad_c1: 'Thiago Nunes', ad_c2: 'Estagiário de TI', ad_c3: 'TI', ad_c5: 'Estágio' } },
    { id: 'ad_card5', titulo: 'Patrícia Gomes', etapaId: 'ad_e7', valores: { ad_c1: 'Patrícia Gomes', ad_c2: 'Analista de Suporte', ad_c3: 'TI', ad_c5: 'CLT' } },
    { id: 'ad_card6', titulo: 'Rodrigo Faria', etapaId: 'ad_e5', etiquetas: ['Home office'], valores: { ad_c1: 'Rodrigo Faria', ad_c2: 'Vendedor Externo', ad_c3: 'Comercial', ad_c5: 'CLT', ad_c7: 'Remoto' } },
  ],
  tour: [
    '📝 Admissão sem esquecer nada — do documento ao fim da experiência.',
    '1️⃣ "Documentação": checklist com 10 documentos. Marcou "completa"? o card anda sozinho.',
    '2️⃣ "Exame Admissional": ASO com resultado. "Apto com restrições" abre o campo de restrições.',
    '3️⃣ "Registro e eSocial": matrícula, contrato e benefícios ativados.',
    '4️⃣ "Recursos e Acessos": TI entrega notebook e cria acessos — dois checklists separados.',
    '5️⃣ "Integração": tour, código de conduta e padrinho definido.',
    '6️⃣ "Período de Experiência": avaliações de 45 e 90 dias, ordenado por vencimento.',
    '✅ Aprovado em 90 dias vira "Efetivado" automaticamente.',
  ],
  etapasDicas: [
    { quemFaz: 'DP / RH', objetivo: 'Reunir toda a documentação antes da data de início — evita admissão irregular.', automacoes: ['Já configurado: documentação completa libera o exame'], conexoes: ['Receba este card automaticamente do fluxo de Recrutamento quando o candidato aceitar'], ondeConfigurar: 'Conexões entre Fluxos > Recrutamento & Seleção > etapa "Contratado"' },
    { quemFaz: 'DP / SESMT', objetivo: 'Garantir o exame admissional antes do primeiro dia (exigência legal).', automacoes: ['Já configurado: restrições aparecem só quando o ASO tem ressalva'], ondeConfigurar: 'Automações > "Mostrar restrições quando houver"' },
    { quemFaz: 'DP', objetivo: 'Registrar em folha, enviar eSocial e ativar benefícios.', automacoes: ['Já configurado: eSocial enviado libera recursos e acessos'], ondeConfigurar: 'Automações > "eSocial enviado libera recursos e acessos"' },
    { quemFaz: 'TI + Facilities', objetivo: 'Entregar equipamento e criar acessos antes do primeiro dia.', conexoes: ['Ligue ao fluxo de Chamados de TI para abrir as solicitações de acesso'], ondeConfigurar: 'Conexões entre Fluxos > Chamados de TI' },
    { quemFaz: 'RH + Gestor', objetivo: 'Fazer a pessoa se sentir parte do time desde o primeiro dia.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'Gestor direto', objetivo: 'Avaliar em 45 e 90 dias — decisão consciente antes de efetivar.', automacoes: ['Já configurado: aprovado em 90 dias vira Efetivado', 'Ative alerta no campo "Fim do 1º Período" para não perder o prazo legal'], ondeConfigurar: 'Automações > "Aprovado em 90 dias vira efetivado"' },
    { quemFaz: 'DP', objetivo: 'Encerrar o processo de admissão com o colaborador efetivado.', ondeConfigurar: 'Configuração da Etapa > Campos' },
  ],
};

const ferias: DefaultTemplate = {
  id: 'tpl_ferias',
  name: 'Solicitação de Férias',
  descricao: 'Programação de férias com validação de saldo, aprovação do gestor, aviso legal de 30 dias e pagamento. Com trilha para reagendamento quando o time não pode liberar na data pedida.',
  categoria: 'rh',
  icone: '🏖️',
  etiquetas: [
    { nome: 'Vence em breve', cor: COR.vermelho },
    { nome: 'Coletiva', cor: COR.azul },
    { nome: 'Abono pecuniário', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'fe_e1', nome: 'Solicitação',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['fe_c1', 'fe_c4', 'fe_c6'],
      permiteMoverPara: ['fe_e2'],
      campos: [
        { id: 'fe_c1', nome: 'Colaborador', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'fe_c2', nome: 'Departamento', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH', 'Financeiro'] },
        { id: 'fe_c3', nome: 'Período Aquisitivo', tipo: 'texto', obrigatorio: false },
        { id: 'fe_c4', nome: 'Data de Início', tipo: 'data', obrigatorio: true },
        { id: 'fe_c5', nome: 'Data de Retorno', tipo: 'data', obrigatorio: true },
        { id: 'fe_c6', nome: 'Dias Solicitados', tipo: 'numero', obrigatorio: true, valorMinimo: 5, valorMaximo: 30 },
        { id: 'fe_c7', nome: 'Vender 10 dias (abono)?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'fe_c8', nome: 'Adiantar 13º?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'fe_c9', nome: 'Quem cobre as atividades', tipo: 'texto', obrigatorio: false },
      ],
    },
    {
      id: 'fe_e2', nome: 'Validação do DP',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['fe_c1', 'fe_c10', 'fe_c11'],
      permiteMoverPara: ['fe_e3', 'fe_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'fe_c10', nome: 'Saldo de Dias', tipo: 'numero', obrigatorio: true },
        { id: 'fe_c11', nome: 'Saldo suficiente?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'fe_c12', nome: 'Limite para Gozo', tipo: 'data_vencimento', obrigatorio: false },
        { id: 'fe_c13', nome: 'Observações do DP', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'fe_e3', nome: 'Aprovação do Gestor',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['fe_c1', 'fe_c4', 'fe_c14'],
      permiteMoverPara: ['fe_e4', 'fe_e6'],
      limparCamposAoRetornar: ['fe_c14', 'fe_c15'],
      permiteCriarCards: false,
      campos: [
        { id: 'fe_c14', nome: 'Aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'fe_c15', nome: 'Comentário do Gestor', tipo: 'texto_longo', obrigatorio: false },
        { id: 'fe_c16', nome: 'Conflita com outras férias do time?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'fe_e4', nome: 'Aviso e Pagamento',
      tempoMaximoHoras: 72,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['fe_c1', 'fe_c4', 'fe_c17'],
      permiteMoverPara: ['fe_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'fe_c17', nome: 'Aviso de férias assinado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'fe_c18', nome: 'Aviso de Férias', tipo: 'anexo', obrigatorio: false },
        { id: 'fe_c19', nome: 'Data do Pagamento', tipo: 'data', obrigatorio: false },
        { id: 'fe_c20', nome: 'Recibo', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'fe_e5', nome: 'Em Gozo / Concluído',
      camposVisiveisNoCard: ['fe_c1', 'fe_c4', 'fe_c5'],
      permiteCriarCards: false,
      campos: [
        { id: 'fe_c21', nome: 'Retornou na data prevista?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'fe_e6', nome: 'Reagendar',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['fe_c1', 'fe_c22'],
      permiteMoverPara: ['fe_e1', 'fe_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'fe_c22', nome: 'Motivo', tipo: 'lista', obrigatorio: true, opcoes: ['Saldo insuficiente', 'Conflito com o time', 'Período crítico da operação', 'Pedido do colaborador'] },
        { id: 'fe_c23', nome: 'Nova Data Sugerida', tipo: 'data', obrigatorio: false },
        { id: 'fe_c24', nome: 'Detalhes', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Saldo insuficiente vai para reagendamento',
      etapaOrigemId: 'fe_e2',
      condicao: { campoId: 'fe_c11', operador: 'igual', valor: 'Não' },
      etapaDestinoId: 'fe_e6',
      etapaDestinoSenaoId: 'fe_e3',
    },
    {
      tipo: 'mover',
      nome: 'Gestor aprovou segue para aviso e pagamento',
      etapaOrigemId: 'fe_e3',
      condicao: { campoId: 'fe_c14', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'fe_e4',
      etapaDestinoSenaoId: 'fe_e6',
    },
    {
      tipo: 'mover',
      nome: 'Aviso assinado libera o gozo',
      etapaOrigemId: 'fe_e4',
      condicao: { campoId: 'fe_c17', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'fe_e5',
    },
  ],
  cards: [
    { id: 'fe_card1', titulo: 'Marina Costa', etapaId: 'fe_e3', valores: { fe_c1: 'Marina Costa', fe_c2: 'Comercial', fe_c6: 20, fe_c7: 'Sim', fe_c10: 30 } },
    { id: 'fe_card2', titulo: 'Rafael Souza', etapaId: 'fe_e4', etiquetas: ['Abono pecuniário'], valores: { fe_c1: 'Rafael Souza', fe_c2: 'Operações', fe_c6: 20, fe_c7: 'Sim', fe_c10: 30 } },
    { id: 'fe_card3', titulo: 'Juliana Reis', etapaId: 'fe_e5', valores: { fe_c1: 'Juliana Reis', fe_c2: 'RH', fe_c6: 15 } },
    { id: 'fe_card4', titulo: 'Pedro Lima', etapaId: 'fe_e2', etiquetas: ['Vence em breve'], valores: { fe_c1: 'Pedro Lima', fe_c2: 'TI', fe_c6: 30, fe_c10: 30 } },
    { id: 'fe_card5', titulo: 'Carlos Menezes', etapaId: 'fe_e6', valores: { fe_c1: 'Carlos Menezes', fe_c2: 'Comercial', fe_c6: 30, fe_c22: 'Conflito com o time', fe_c24: 'Dois vendedores da mesma carteira no mesmo período.' } },
    { id: 'fe_card6', titulo: 'Fernanda Dias', etapaId: 'fe_e1', valores: { fe_c1: 'Fernanda Dias', fe_c2: 'Financeiro', fe_c6: 10 } },
  ],
  tour: [
    '🏖️ Férias organizadas: saldo conferido, gestor ciente e aviso no prazo legal.',
    '1️⃣ "Solicitação": o colaborador escolhe o período, abono e quem cobre suas atividades.',
    '2️⃣ "Validação do DP": confere saldo. Insuficiente? vai direto para "Reagendar".',
    '3️⃣ "Aprovação do Gestor": ele vê se conflita com outras férias do time.',
    '4️⃣ "Aviso e Pagamento": aviso assinado (30 dias antes) e recibo anexado.',
    '5️⃣ "Em Gozo / Concluído": férias acontecendo ou já encerradas.',
    '🔄 "Reagendar" tem motivo registrado e sugestão de nova data — nada se perde.',
  ],
  etapasDicas: [
    { quemFaz: 'Colaborador', objetivo: 'Programar férias com antecedência e indicar quem cobre suas tarefas.', ondeConfigurar: 'Configuração da Etapa > Campos' },
    { quemFaz: 'DP', objetivo: 'Validar saldo e limite legal de gozo antes de envolver o gestor.', automacoes: ['Já configurado: saldo insuficiente vai para Reagendar'], ondeConfigurar: 'Automações > "Saldo insuficiente vai para reagendamento"' },
    { quemFaz: 'Gestor direto', objetivo: 'Garantir que a área não fica descoberta no período.', automacoes: ['Já configurado: aprovado segue, reprovado vai para Reagendar'], ondeConfigurar: 'Automações > "Gestor aprovou segue para aviso e pagamento"' },
    { quemFaz: 'DP', objetivo: 'Emitir aviso 30 dias antes e pagar até 2 dias antes do início (exigência legal).', automacoes: ['Já configurado: aviso assinado libera o gozo', 'Ative alerta de SLA para não estourar o prazo legal'], ondeConfigurar: 'Configuração da Etapa > SLA e Alertas' },
    { quemFaz: 'DP', objetivo: 'Acompanhar o gozo e confirmar o retorno na data.', conexoes: ['O módulo Atlas já mostra o saldo de férias vindo do sistema de folha'], ondeConfigurar: 'Atlas > Férias' },
    { quemFaz: 'DP + Gestor + Colaborador', objetivo: 'Realinhar a data sem perder a solicitação original.', ondeConfigurar: 'Configuração da Etapa > Transições permitidas' },
  ],
};

const desligamento: DefaultTemplate = {
  id: 'tpl_desligamento',
  name: 'Desligamento de Colaborador',
  descricao: 'Processo de saída com checklist de devoluções, corte de acessos, entrevista de desligamento, homologação e rescisão paga. Protege a empresa e encerra bem a relação.',
  categoria: 'rh',
  icone: '👋',
  etiquetas: [
    { nome: 'Justa causa', cor: COR.vermelho },
    { nome: 'Pedido de demissão', cor: COR.azul },
    { nome: 'Acordo', cor: COR.amarelo },
  ],
  etapas: [
    {
      id: 'dg_e1', nome: 'Comunicação do Desligamento',
      tempoMaximoHoras: 24,
      camposVisiveisNoCard: ['dg_c1', 'dg_c4', 'dg_c5'],
      permiteMoverPara: ['dg_e2'],
      campos: [
        { id: 'dg_c1', nome: 'Colaborador', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'dg_c2', nome: 'Cargo', tipo: 'texto', obrigatorio: false },
        { id: 'dg_c3', nome: 'Departamento', tipo: 'lista', obrigatorio: true, opcoes: ['Administrativo', 'Comercial', 'Operações', 'TI', 'Marketing', 'RH', 'Financeiro'] },
        { id: 'dg_c4', nome: 'Tipo de Desligamento', tipo: 'lista', obrigatorio: true, opcoes: ['Pedido de demissão', 'Sem justa causa', 'Com justa causa', 'Acordo (Lei 13.467)', 'Fim de contrato', 'Aposentadoria'], coresOpcoes: { 'Com justa causa': COR.vermelho, 'Pedido de demissão': COR.azul, 'Acordo (Lei 13.467)': COR.amarelo } },
        { id: 'dg_c5', nome: 'Último Dia de Trabalho', tipo: 'data', obrigatorio: true },
        { id: 'dg_c6', nome: 'Cumprirá aviso prévio?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'dg_c7', nome: 'Motivo / Contexto', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'dg_e2', nome: 'Devoluções e Acessos',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['dg_c1', 'dg_c8'],
      permiteMoverPara: ['dg_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'dg_c8', nome: 'Itens Devolvidos', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['Notebook', 'Celular corporativo', 'Crachá', 'Uniforme', 'EPI', 'Chaves', 'Cartão corporativo', 'Veículo'] },
        { id: 'dg_c9', nome: 'Acessos Revogados', tipo: 'checkbox_multi', obrigatorio: true, opcoes: ['E-mail corporativo', 'ERP', 'CRM', 'VPN', 'Acesso físico', 'Grupos de WhatsApp'] },
        { id: 'dg_c10', nome: 'Pendências de Devolução', tipo: 'texto_longo', obrigatorio: false },
        { id: 'dg_c11', nome: 'Termo de Devolução', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'dg_e3', nome: 'Transferência de Conhecimento',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['dg_c1', 'dg_c12'],
      permiteMoverPara: ['dg_e4'],
      permiteCriarCards: false,
      campos: [
        { id: 'dg_c12', nome: 'Substituto / Quem assume', tipo: 'texto', obrigatorio: false },
        { id: 'dg_c13', nome: 'Passagem de bastão concluída?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'dg_c14', nome: 'Atividades e Pendências Repassadas', tipo: 'texto_longo', obrigatorio: false },
        { id: 'dg_c15', nome: 'Documentação Entregue', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'dg_e4', nome: 'Entrevista de Desligamento',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['dg_c1', 'dg_c18'],
      permiteMoverPara: ['dg_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'dg_c16', nome: 'Entrevista realizada?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'dg_c17', nome: 'Motivo Declarado da Saída', tipo: 'lista', obrigatorio: false, opcoes: ['Proposta melhor', 'Salário', 'Liderança', 'Falta de crescimento', 'Clima / cultura', 'Motivo pessoal', 'Mudança de cidade', 'Não declarou'] },
        { id: 'dg_c18', nome: 'Recomendaria a empresa? (0-10)', tipo: 'numero', obrigatorio: false, valorMinimo: 0, valorMaximo: 10 },
        { id: 'dg_c19', nome: 'Pontos Positivos', tipo: 'texto_longo', obrigatorio: false },
        { id: 'dg_c20', nome: 'Pontos de Melhoria', tipo: 'texto_longo', obrigatorio: false },
        { id: 'dg_c21', nome: 'Recontrataria?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'dg_e5', nome: 'Rescisão e Homologação',
      tempoMaximoHoras: 240,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['dg_c1', 'dg_c23', 'dg_c24'],
      permiteMoverPara: ['dg_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'dg_c22', nome: 'TRCT', tipo: 'anexo', obrigatorio: false },
        { id: 'dg_c23', nome: 'Valor da Rescisão', tipo: 'valor', obrigatorio: false },
        { id: 'dg_c24', nome: 'Prazo Legal de Pagamento', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'dg_c25', nome: 'Rescisão paga?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'dg_c26', nome: 'Chave do FGTS liberada?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'dg_c27', nome: 'eSocial - desligamento enviado?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'dg_e6', nome: 'Concluído',
      camposVisiveisNoCard: ['dg_c1', 'dg_c4'],
      permiteCriarCards: false,
      campos: [
        { id: 'dg_c28', nome: 'Exame Demissional', tipo: 'anexo', obrigatorio: false },
        { id: 'dg_c29', nome: 'Observações Finais', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Passagem de bastão concluída libera a entrevista',
      etapaOrigemId: 'dg_e3',
      condicao: { campoId: 'dg_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'dg_e4',
    },
    {
      tipo: 'mover',
      nome: 'Rescisão paga encerra o processo',
      etapaOrigemId: 'dg_e5',
      condicao: { campoId: 'dg_c25', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'dg_e6',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Detalhar motivo quando for justa causa',
      etapaOrigemId: 'dg_e1',
      condicao: { campoId: 'dg_c4', operador: 'igual', valor: 'Com justa causa' },
      camposAfetadosIds: ['dg_c7'],
    },
  ],
  cards: [
    { id: 'dg_card1', titulo: 'Carlos Menezes', etapaId: 'dg_e5', etiquetas: ['Pedido de demissão'], valores: { dg_c1: 'Carlos Menezes', dg_c2: 'Vendedor', dg_c3: 'Comercial', dg_c4: 'Pedido de demissão', dg_c23: 8400 } },
    { id: 'dg_card2', titulo: 'Roberta Silva', etapaId: 'dg_e2', valores: { dg_c1: 'Roberta Silva', dg_c2: 'Analista de Suporte', dg_c3: 'TI', dg_c4: 'Sem justa causa' } },
    { id: 'dg_card3', titulo: 'Anderson Paiva', etapaId: 'dg_e4', etiquetas: ['Acordo'], valores: { dg_c1: 'Anderson Paiva', dg_c2: 'Auxiliar Administrativo', dg_c3: 'Administrativo', dg_c4: 'Acordo (Lei 13.467)', dg_c18: 8 } },
    { id: 'dg_card4', titulo: 'Vanessa Rocha', etapaId: 'dg_e6', valores: { dg_c1: 'Vanessa Rocha', dg_c2: 'Analista de Marketing', dg_c3: 'Marketing', dg_c4: 'Pedido de demissão' } },
    { id: 'dg_card5', titulo: 'Luiz Fernando Braga', etapaId: 'dg_e3', valores: { dg_c1: 'Luiz Fernando Braga', dg_c2: 'Coordenador de Operações', dg_c3: 'Operações', dg_c4: 'Sem justa causa', dg_c12: 'Rafael Souza' } },
  ],
  tour: [
    '👋 Encerrar bem é tão importante quanto contratar bem.',
    '1️⃣ "Comunicação": tipo de desligamento, último dia e aviso prévio.',
    '2️⃣ "Devoluções e Acessos": dois checklists — o que volta e o que precisa ser cortado.',
    '3️⃣ "Transferência de Conhecimento": quem assume e o que ficou pendente.',
    '4️⃣ "Entrevista de Desligamento": por que a pessoa saiu — dado de ouro para reduzir turnover.',
    '5️⃣ "Rescisão": prazo legal de pagamento com alerta de vencimento.',
    '✅ Rescisão paga encerra o card automaticamente.',
    '⚠️ Justa causa abre o campo de motivo detalhado — registro essencial se virar processo.',
  ],
  etapasDicas: [
    { quemFaz: 'Gestor + RH', objetivo: 'Formalizar a saída e definir a data de corte.', automacoes: ['Já configurado: justa causa abre o campo de motivo detalhado'], ondeConfigurar: 'Automações > "Detalhar motivo quando for justa causa"' },
    { quemFaz: 'TI + Facilities + Gestor', objetivo: 'Recolher patrimônio e cortar acessos no mesmo dia — segurança da informação.', conexoes: ['Ligue a Chamados de TI para abrir a revogação de acessos automaticamente'], ondeConfigurar: 'Conexões entre Fluxos > Chamados de TI' },
    { quemFaz: 'Colaborador que sai + substituto', objetivo: 'Não deixar conhecimento sair pela porta junto com a pessoa.', automacoes: ['Já configurado: passagem concluída libera a entrevista'], ondeConfigurar: 'Automações > "Passagem de bastão concluída libera a entrevista"' },
    { quemFaz: 'RH', objetivo: 'Entender o motivo real da saída e medir o eNPS de desligamento.', conexoes: ['O módulo Atlas consolida os motivos de saída em relatório de turnover'], ondeConfigurar: 'Atlas > Offboarding' },
    { quemFaz: 'DP', objetivo: 'Pagar dentro do prazo legal (10 dias) — atraso gera multa automática.', automacoes: ['Já configurado: rescisão paga encerra o processo', 'Ative alerta no "Prazo Legal de Pagamento"'], ondeConfigurar: 'Configuração da Etapa > Alerta de vencimento' },
    { quemFaz: 'DP', objetivo: 'Arquivar exame demissional e fechar o dossiê do colaborador.', ondeConfigurar: 'Configuração da Etapa > Campos' },
  ],
};

const treinamentos: DefaultTemplate = {
  id: 'tpl_treinamentos',
  name: 'Treinamentos & Capacitação',
  descricao: 'Planeje, aprove, execute e meça treinamentos: da identificação da necessidade à avaliação de eficácia 60 dias depois. Com controle de orçamento e certificados anexados.',
  categoria: 'rh',
  icone: '🎓',
  etiquetas: [
    { nome: 'Obrigatório (NR)', cor: COR.vermelho },
    { nome: 'Desenvolvimento', cor: COR.azul },
    { nome: 'Externo', cor: COR.roxo },
  ],
  etapas: [
    {
      id: 'tr_e1', nome: 'Necessidade Identificada',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['tr_c1', 'tr_c3', 'tr_c5'],
      permiteMoverPara: ['tr_e2'],
      campos: [
        { id: 'tr_c1', nome: 'Tema do Treinamento', tipo: 'texto', obrigatorio: true, usarComoTitulo: true },
        { id: 'tr_c2', nome: 'Justificativa', tipo: 'texto_longo', obrigatorio: true },
        { id: 'tr_c3', nome: 'Tipo', tipo: 'lista', obrigatorio: true, opcoes: ['Obrigatório / NR', 'Técnico', 'Comportamental', 'Liderança', 'Compliance', 'Onboarding'], coresOpcoes: { 'Obrigatório / NR': COR.vermelho, 'Técnico': COR.azul, 'Liderança': COR.roxo } },
        { id: 'tr_c4', nome: 'Público-alvo', tipo: 'texto', obrigatorio: true },
        { id: 'tr_c5', nome: 'Nº de Participantes', tipo: 'numero', obrigatorio: false },
        { id: 'tr_c6', nome: 'Origem da Demanda', tipo: 'lista', obrigatorio: false, opcoes: ['Avaliação de desempenho', 'Exigência legal', 'Pedido do gestor', 'Plano de desenvolvimento', 'Novo processo / sistema'] },
      ],
    },
    {
      id: 'tr_e2', nome: 'Planejamento',
      tempoMaximoHoras: 120,
      camposVisiveisNoCard: ['tr_c1', 'tr_c9', 'tr_c11'],
      permiteMoverPara: ['tr_e3'],
      permiteCriarCards: false,
      campos: [
        { id: 'tr_c7', nome: 'Modalidade', tipo: 'lista', obrigatorio: true, opcoes: ['Presencial', 'Online ao vivo', 'EAD gravado', 'Híbrido'] },
        { id: 'tr_c8', nome: 'Instrutor / Fornecedor', tipo: 'texto', obrigatorio: false },
        { id: 'tr_c9', nome: 'Custo Estimado', tipo: 'valor', obrigatorio: false },
        { id: 'tr_c10', nome: 'Carga Horária', tipo: 'numero', obrigatorio: false },
        { id: 'tr_c11', nome: 'Data Prevista', tipo: 'data', obrigatorio: false },
        { id: 'tr_c12', nome: 'Conteúdo Programático', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'tr_e3', nome: 'Aprovação',
      tempoMaximoHoras: 48,
      camposVisiveisNoCard: ['tr_c1', 'tr_c9', 'tr_c13'],
      permiteMoverPara: ['tr_e4', 'tr_e7'],
      permiteCriarCards: false,
      campos: [
        { id: 'tr_c13', nome: 'Aprovado?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'tr_c14', nome: 'Verba Aprovada', tipo: 'valor', obrigatorio: false },
        { id: 'tr_c15', nome: 'Parecer', tipo: 'texto_longo', obrigatorio: false },
      ],
    },
    {
      id: 'tr_e4', nome: 'Agendado',
      tempoMaximoHoras: 168,
      ordenacaoCards: 'vencimento_proximo',
      camposVisiveisNoCard: ['tr_c1', 'tr_c16', 'tr_c17'],
      permiteMoverPara: ['tr_e5'],
      permiteCriarCards: false,
      campos: [
        { id: 'tr_c16', nome: 'Data Confirmada', tipo: 'data_vencimento', obrigatorio: true },
        { id: 'tr_c17', nome: 'Local / Link', tipo: 'texto', obrigatorio: false },
        { id: 'tr_c18', nome: 'Convites enviados?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
        { id: 'tr_c19', nome: 'Lista de Inscritos', tipo: 'anexo', obrigatorio: false },
      ],
    },
    {
      id: 'tr_e5', nome: 'Realizado',
      tempoMaximoHoras: 72,
      camposVisiveisNoCard: ['tr_c1', 'tr_c21', 'tr_c22'],
      permiteMoverPara: ['tr_e6'],
      permiteCriarCards: false,
      campos: [
        { id: 'tr_c20', nome: 'Lista de Presença', tipo: 'anexo', obrigatorio: true },
        { id: 'tr_c21', nome: 'Presentes', tipo: 'numero', obrigatorio: true },
        { id: 'tr_c22', nome: 'Nota Média de Satisfação (0-10)', tipo: 'numero', obrigatorio: false, valorMinimo: 0, valorMaximo: 10 },
        { id: 'tr_c23', nome: 'Certificados', tipo: 'anexo', obrigatorio: false },
        { id: 'tr_c24', nome: 'Custo Real', tipo: 'valor', obrigatorio: false },
      ],
    },
    {
      id: 'tr_e6', nome: 'Avaliação de Eficácia',
      tempoMaximoHoras: 1440,
      camposVisiveisNoCard: ['tr_c1', 'tr_c26'],
      permiteCriarCards: false,
      campos: [
        { id: 'tr_c25', nome: 'Data da Avaliação (60 dias depois)', tipo: 'data', obrigatorio: false },
        { id: 'tr_c26', nome: 'Houve mudança prática?', tipo: 'lista', obrigatorio: true, opcoes: ['Sim, claramente', 'Parcialmente', 'Não'], coresOpcoes: { 'Sim, claramente': COR.verde, 'Parcialmente': COR.amarelo, 'Não': COR.vermelho } },
        { id: 'tr_c27', nome: 'Evidências de Aplicação', tipo: 'texto_longo', obrigatorio: false },
        { id: 'tr_c28', nome: 'Repetir este treinamento?', tipo: 'lista', obrigatorio: false, opcoes: ['Sim', 'Não'], coresOpcoes: CORES_SIM_NAO },
      ],
    },
    {
      id: 'tr_e7', nome: 'Não Aprovado',
      camposVisiveisNoCard: ['tr_c1', 'tr_c29'],
      permiteMoverPara: ['tr_e2'],
      permiteCriarCards: false,
      campos: [
        { id: 'tr_c29', nome: 'Motivo', tipo: 'texto_longo', obrigatorio: true },
        { id: 'tr_c30', nome: 'Reavaliar quando?', tipo: 'data', obrigatorio: false },
      ],
    },
  ],
  automacoes: [
    {
      tipo: 'mover',
      nome: 'Aprovado vai para agendamento',
      etapaOrigemId: 'tr_e3',
      condicao: { campoId: 'tr_c13', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'tr_e4',
      etapaDestinoSenaoId: 'tr_e7',
    },
    {
      tipo: 'mover',
      nome: 'Lista de presença anexada marca como realizado',
      etapaOrigemId: 'tr_e4',
      condicao: { campoId: 'tr_c18', operador: 'igual', valor: 'Sim' },
      etapaDestinoId: 'tr_e5',
    },
    {
      tipo: 'exibir_ocultar',
      nome: 'Mostrar verba aprovada só quando aprovar',
      etapaOrigemId: 'tr_e3',
      condicao: { campoId: 'tr_c13', operador: 'igual', valor: 'Sim' },
      camposAfetadosIds: ['tr_c14'],
    },
  ],
  cards: [
    { id: 'tr_card1', titulo: 'NR-35 - Trabalho em Altura', etapaId: 'tr_e4', etiquetas: ['Obrigatório (NR)'], valores: { tr_c1: 'NR-35 - Trabalho em Altura', tr_c3: 'Obrigatório / NR', tr_c4: 'Equipe de manutenção', tr_c5: 12, tr_c9: 4800 } },
    { id: 'tr_card2', titulo: 'Liderança para novos gestores', etapaId: 'tr_e2', etiquetas: ['Desenvolvimento', 'Externo'], valores: { tr_c1: 'Liderança para novos gestores', tr_c3: 'Liderança', tr_c4: 'Coordenadores e supervisores', tr_c5: 8, tr_c9: 12000 } },
    { id: 'tr_card3', titulo: 'LGPD na prática', etapaId: 'tr_e6', valores: { tr_c1: 'LGPD na prática', tr_c3: 'Compliance', tr_c4: 'Toda a empresa', tr_c21: 46, tr_c22: 9, tr_c26: 'Sim, claramente' } },
    { id: 'tr_card4', titulo: 'Excel avançado para o financeiro', etapaId: 'tr_e5', valores: { tr_c1: 'Excel avançado para o financeiro', tr_c3: 'Técnico', tr_c4: 'Equipe financeira', tr_c21: 6, tr_c22: 8 } },
    { id: 'tr_card5', titulo: 'Atendimento ao cliente difícil', etapaId: 'tr_e1', valores: { tr_c1: 'Atendimento ao cliente difícil', tr_c3: 'Comportamental', tr_c4: 'Equipe de suporte' } },
    { id: 'tr_card6', titulo: 'MBA para diretoria', etapaId: 'tr_e7', valores: { tr_c1: 'MBA para diretoria', tr_c3: 'Liderança', tr_c4: 'Diretoria', tr_c29: 'Sem verba no orçamento deste ano. Reavaliar no próximo ciclo.' } },
  ],
  tour: [
    '🎓 Treinamento com começo, meio e — o mais esquecido — medição de resultado.',
    '1️⃣ "Necessidade": de onde veio a demanda (avaliação, exigência legal, gestor).',
    '2️⃣ "Planejamento": modalidade, instrutor, custo e carga horária.',
    '3️⃣ "Aprovação": aprovou libera a verba; reprovou registra o motivo e a data de reavaliação.',
    '4️⃣ "Agendado": data confirmada e convites enviados.',
    '5️⃣ "Realizado": lista de presença, satisfação e certificados anexados.',
    '6️⃣ "Avaliação de Eficácia": 60 dias depois — mudou alguma coisa na prática?',
    '💰 Compare "Custo Estimado" com "Custo Real" e acerte o orçamento do próximo ano.',
  ],
  etapasDicas: [
    { quemFaz: 'RH / Gestor', objetivo: 'Registrar a necessidade com justificativa — treinamento sem motivo vira custo.', conexoes: ['O módulo Atlas puxa necessidades das avaliações de desempenho e do PDI'], ondeConfigurar: 'Atlas > PDI e Avaliação de Desempenho' },
    { quemFaz: 'RH', objetivo: 'Desenhar o treinamento e cotar fornecedor antes de pedir verba.', conexoes: ['Ligue a Requisição de Compra quando o treinamento for contratado de fora'], ondeConfigurar: 'Conexões entre Fluxos > Requisição de Compra' },
    { quemFaz: 'Diretoria / RH', objetivo: 'Liberar verba com clareza do custo e do público atendido.', automacoes: ['Já configurado: aprovado agenda, reprovado registra o motivo', 'Já configurado: verba aprovada só aparece quando aprovado'], ondeConfigurar: 'Automações > "Aprovado vai para agendamento"' },
    { quemFaz: 'RH', objetivo: 'Confirmar data, local e presença dos convidados.', automacoes: ['Já configurado: convites enviados movem para Realizado quando o treinamento acontece'], ondeConfigurar: 'Automações > "Lista de presença anexada marca como realizado"' },
    { quemFaz: 'RH', objetivo: 'Registrar presença, satisfação e emitir certificados.', conexoes: ['O módulo Atlas registra os treinamentos na ficha de cada colaborador'], ondeConfigurar: 'Atlas > Treinamentos' },
    { quemFaz: 'Gestor da área', objetivo: 'Verificar 60 dias depois se o treinamento mudou o comportamento — a única métrica que importa.', ondeConfigurar: 'Configuração da Etapa > SLA' },
    { quemFaz: 'RH', objetivo: 'Guardar a demanda reprovada para reavaliar no próximo orçamento.', ondeConfigurar: 'Configuração da Etapa > Campos' },
  ],
};

export const TEMPLATES_RH: DefaultTemplate[] = [
  recrutamento,
  admissao,
  ferias,
  desligamento,
  treinamentos,
];
